import data from "@iconify/icons-eva/search-fill";
import { invokeApi } from "../invokeApi";

export const List_Action_History = async (data, id) => {
  const requestObj = {
    path: `/api/ad_account/list_status_type_base_for_accounts/${id}`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data || {},
  };
  return invokeApi(requestObj);
};

export const List_Account_Appeals_For_Admin = async (data, page, limit) => {
  const requestObj = {
    path: `/api/ad_account/list_account_appeals_for_admin?page=${page}&limit=${limit}`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data || {},
  };
  return invokeApi(requestObj);
};

export const Update_Acount_Appeal_Status = async (data, id) => {
  const requestObj = {
    path: `/api/ad_account/update_status_account_appeal/${id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data || {},
  };
  return invokeApi(requestObj);
};

export const List_Account_Topup_For_Admin = async (data, page, limit) => {
  const requestObj = {
    path: `/api/ad_account/list_account_topup_for_admin?page=${page}&limit=${limit}`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data || {},
  };
  return invokeApi(requestObj);
};

export const Update_Acount_Top_Up_Status = async (data, id) => {
  const requestObj = {
    path: `/api/ad_account/update_status_account_topup/${id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data || {},
  };
  return invokeApi(requestObj);
};

export const List_Account_WithDrawal_List = async (data, page, limit) => {
  const requestObj = {
    path: `/api/ad_account/list_account_withdraw_fund_for_admin?page=${page}&limit=${limit}`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data || {},
  };
  return invokeApi(requestObj);
};

export const Update_Account_WithDrawal_Status = async (data, id) => {
  const requestObj = {
    path: `/api/ad_account/update_status_account_withdraw_funds/${id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data || {},
  };
  return invokeApi(requestObj);
};

export const clear_wallet_details_Update = async (data, id) => {
  const requestObj = {
    path: `/api/transaction/update_status_clear_wallet_transaction/${id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data || {},
  };
  return invokeApi(requestObj);
};
